import type {
    BimActKc2Data,
    BimLimitedCostTypeEnum,
    ContractStatusEnum,
    WorkOrderStatusEnum,
    ProjectStatusEnum,
    BimActKc2VersionData,
    BimCalculateInflationEnum,
} from 'gql/graphql';

export interface BimActKc2DataExtended extends BimActKc2Data {
    isActRow?: boolean;
}

export interface BimActKc2DataVersionExtended extends BimActKc2VersionData {
    isActRow?: boolean;
}

export interface IActTotalDetailsProps {
    updateLimitedHandler: (requestVariables: {
        actKC2Id: number;
        limitedItems: BimLimitedCostTypeEnum[];
        useLimited: boolean;
    }) => void;
    resetCalculatedHandler: (requestVariables: { actKC2Id: number; actKC2TotalItemId?: number | undefined }) => void;
    setInputValueHandler: (requestVariables: { actKC2Id: number; actKC2TotalItemId: number; value: number }) => void;
    setTotalInflationHandler: (requestVariables: { actKC2Id: number; workOrderSeasonId: number }) => void;
    actKC2Id: number;
    contractStatus?: ContractStatusEnum;
    workOrderStatus?: WorkOrderStatusEnum;
    statusProject?: ProjectStatusEnum;
    isVersion?: boolean;
    isActionDisabled?: boolean;
    isReadOnly?: boolean;
    inflationCalcType?: BimCalculateInflationEnum;
    isCommitting?: boolean;
}

export enum ActTotalDetailsType {
    Totals = 'Totals',
    Prices = 'Prices',
}
